import { api } from './client'

export const getCompany = async () => {
  const { data } = await api.get('/settings/company')
  return data
}

export const saveCompany = async (payload) => {
  const { data } = await api.post('/settings/company', payload)
  return data
}

export const uploadLogo = async (file) => {
  const form = new FormData()
  form.append('file', file)
  const { data } = await api.post('/settings/company/logo', form, { headers: { 'Content-Type': 'multipart/form-data' } })
  return data
}

export const removeLogo = async () => {
  const { data } = await api.delete('/settings/company/logo')
  return data
}

// App configuration (feature flags)
export const getConfig = async () => {
  const { data } = await api.get('/settings/config')
  return data // { bin_tracking: boolean }
}

export const saveConfig = async (payload) => {
  const { data } = await api.post('/settings/config', payload)
  return data // { ok: true }
}

/** Offer an admin's device time zone to a company with no clock of its own
    yet; the API saves it only then. { saved, time_zone, time_zone_source } */
export const timeZoneFromDevice = async (timeZone) => (await api.post('/settings/time-zone/device', { time_zone: timeZone })).data

/** The plan: { account, lines, tiers, plans, current, extra_user, extra_location, trial_days, history } (admins). */
export const getPlan = async () => (await api.get('/settings/plan')).data
/** Change the plan: { plan, addons, extra_users, extra_locations, confirm? }. A change that turns
    modules off fails with status 409 and data.lost until it's confirmed. */
export const changePlan = async (payload) => (await api.post('/settings/plan', payload)).data
